export const appleConfig = {
    clientId: '3303.ua',
    redirectURI:'https://dev.3303.ua/auth/callback/apple'
}

